import { IDriver } from "models/driver";
import moment from "moment";

interface IProps {
  data?: IDriver | undefined;
}

export default function BasicInfo({ data }: IProps) {
  return (
    <div
      className="w-full lg:w-1/2 bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full">
        <h4 className="text-lg font-medium">Basic Information</h4>
        <div className="w-full mt-6 flex flex-wrap">
          <div className="flex flex-col">
            <table className="text-sm">
              <tbody>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Birth Date </td>
                  <td className="min-w-36">
                    {moment(data?.date_of_birth).format("DD	MMM, YYYY")}
                  </td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Phone Number</td>
                  <td className="min-w-36">{data?.phone}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Backup Phone</td>
                  <td className="min-w-36">{data?.backup_phone}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">Gender</td>
                  <td className="min-w-36">{data?.gender}</td>
                </tr>
                <tr className="mt-4">
                  <td className="font-bold min-w-36">City</td>
                  <td className="min-w-36">{data?.city.name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
